
import { defineComponent } from 'vue'
// export default {

export default defineComponent({
	name: 'AppView',
	data(){
		return {
			userProfile: {
				name: '',
				email: '',
			} as object,
		};
	},
	methods: {
		/** Fetch user profile */
		/*
		async fetchUserProfile(){
			try {
				const settings = {
					method: 'GET',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Credentials': 'same-origin', // This sends the cookies along with the request
					},
					body: JSON.stringify({
						username: 'admin',
						password: 'password',
					}),
				};
				const response = await fetch('/jwt-auth/v1/token', settings);
				// const response = await fetch('/wp-json/wp/v2/users/me', settings);
				// $http.post( apiHost + '/jwt-auth/v1/token', {
				// 	username: 'admin',
				// 	password: 'password'
				// })
				//const response = await fetch('/wp-json/wp/v2/users/me', {
				// const response = await fetch('/wp-json/wp/v2/posts', {
				console.log('response', response);
				this.userProfile = await response.json();
			} catch (error){
				console.error('Error fetching user profile:', error);
			}
		},
		*/
	},
	mounted(){
		// this.fetchUserProfile();
	},
// };
});
